<section class="summary-card">
  <div class="summary-card-header">
    <img class="summary-main-icon" src="assets/Image/icons-donate/modal/icon-summary-receipt.svg"
      alt="Donation Summary Icon">

    <h3 class="summary-title m-0">
      {{ 'CAMPAIGN.DonationSummary' | translate }}
    </h3>
  </div>

  <div class="summary-divider"></div>

  <div class="summary-row">
    <img class="summary-row-icon" src="assets/Image/icons-donate/modal/icon-calendar-purple.svg"
      alt="Donation Type Icon">

    <div class="summary-row-content">
      <strong>{{ 'CAMPAIGN.Type' | translate }}</strong>

      <span>
        {{
        summary?.donationType === 'recurring'
        ? ('CAMPAIGN.DonationType.Monthly' | translate)
        : ('CAMPAIGN.DonationType.OneTime' | translate)
        }}
      </span>
    </div>
  </div>

  <div class="summary-row" *ngIf="summary?.campaignName">
    <img class="summary-row-icon" src="assets/Image/icons-donate/modal/icon-community-purple.svg" alt="Campaign Icon">

    <div class="summary-row-content">
      <strong>{{ 'CAMPAIGN.Campaign' | translate }}</strong>
      <span>{{ summary?.campaignName }}</span>
    </div>
  </div>

  <div class="summary-row" *ngIf="summary?.donorName || summary?.donorEmail">
    <img class="summary-row-icon" src="assets/Image/icons-donate/modal/icon-user-purple.svg" alt="Donor Icon">

    <div class="summary-row-content">
      <strong>{{ 'CAMPAIGN.Donor' | translate }}</strong>

      <div class="summary-donor">
        <span *ngIf="summary?.donorName">{{ summary?.donorName }}</span>

        <span class="summary-email" *ngIf="summary?.donorEmail">
          {{ summary?.donorEmail }}
        </span>
      </div>
    </div>
  </div>

  <div class="summary-divider"></div>

  <div class="summary-row">
    <img class="summary-row-icon" src="assets/Image/icons-donate/modal/icon-dollar-purple.svg" alt="Amount Icon">

    <div class="summary-row-content">
      <strong>{{ 'CAMPAIGN.Amount' | translate }}</strong>

      <span>
        {{ summary?.amount | currency:(summary?.currency | uppercase):'symbol':'1.2-2' }}
        {{ summary?.currency | uppercase }}
        <span *ngIf="summary?.donationType === 'recurring'" class="summary-frequency">/mo</span>
      </span>
    </div>
  </div>

  <div class="summary-row">
    <img class="summary-row-icon" src="assets/Image/icons-donate/modal/icon-tag-purple.svg" alt="Fees Icon">

    <div class="summary-row-content">
      <strong class="summary-fees-label">
        {{ 'CAMPAIGN.Fees' | translate }}
      </strong>

      <span class="summary-fees-value">
        {{ summary?.fees | currency:(summary?.currency | uppercase):'symbol':'1.2-2' }}
        {{ summary?.currency | uppercase }}

        <ng-container *ngIf="summary?.feesCovered; else notCovered">
          <small>({{ 'CAMPAIGN.Covered' | translate }})</small>
        </ng-container>

        <ng-template #notCovered>
          <small>(not covered)</small>
        </ng-template>
      </span>
    </div>
  </div>

  <div class="summary-divider"></div>

  <div class="summary-total-row">
    <strong>{{ 'CAMPAIGN.TotalAmountPaid' | translate }}</strong>

    <span>
      {{ summary?.total | currency:(summary?.currency | uppercase):'symbol':'1.2-2' }}
      {{ summary?.currency | uppercase }}
    </span>
  </div>

  <div class="summary-secure-transaction">
    <img src="assets/Image/icons-donate/modal/icon-lock-gray.svg" alt="Secure transaction" />

    <p class="m-0">{{ 'CAMPAIGN.SecureTransaction' | translate }}</p>
  </div>
</section>